module.exports = __webpack_public_path__ + "img/dropped-image-1.f938e8a4.png";